import { Outlet, createRootRoute } from "@tanstack/react-router";
import { supabase } from "@/lib/supabase/supabaseClient";
import Providers from "@/components/providers";
import RootErrorFallback from "@/components/RootErrorFallback";
import NotFound from "@/components/NotFound";
import DocumentTitleManager from "@/components/DocumentTitleManager";

export const Route = createRootRoute({
  component: RootComponent,
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    return {
      session,
    };
  },
  errorComponent: RootErrorFallback,
  notFoundComponent: NotFound,
});

// const TanStackRouterDevtools = import.meta.env.PROD
//   ? () => null // Render nothing in production
//   : React.lazy(() =>
//       // Lazy load in development
//       import("@tanstack/router-devtools").then((res) => ({
//         default: res.TanStackRouterDevtools,
//       }))
//     );

function RootComponent() {
  return (
    <>
      <Providers>
        <DocumentTitleManager />
        <Outlet />
      </Providers>
      {/* <React.Suspense>
        <TanStackRouterDevtools position="bottom-right" />
      </React.Suspense> */}
    </>
  );
}
